import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { GoogleAnalyticsService } from '../shared/google-analytics.service';

@Component({
  selector: 'app-submissions-closed',
  templateUrl: './submissions-closed.component.html',
  styleUrls: ['./submissions-closed.component.css']
})
export class SubmissionsClosedComponent implements OnInit {
  fraternalYear = environment.fraternalYear;

  constructor(private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit() {
  }

  openSupremeSite() {
    this.googleAnalyticsService.eventEmitter('open_supreme_10784_site', 'Open Supreme 10784 Site');
    window.open('https://kofc.org/un/en/forms/spa/invite.html?lang=en&form=10784C.01', '_blank');
  }
}
